import React, { useState, useEffect, useRef } from 'react';
import { Carousel } from 'react-bootstrap';
import CustomSpinner from './CustomSpinner';
import useLocalize from '../utils/hooks/useLocalize';
import { closeForm } from '../utils/dataProcessing';

const CarouselComp = ({ match }) => {
  const { platform, version, userStatus } = match.params;
  const { localize } = useLocalize();

  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex, e) => {
    carouselEL.current.element.scrollTop = 0;
    setIndex(selectedIndex);
  };

  const handleClick = x => () => {
    carouselEL.current.element.scrollTop = 0;
    setIndex(prevIndex => prevIndex + x);
  };

  const carouselEL = useRef();

  const [loading, setLoading] = useState(true);
  const [imageState, setImageState] = useState({
    imageIndex: 1,
    imageArray: [],
  });

  useEffect(() => {
    const img = new Image();
    img.src = `https://myverifly.com/apptutorial/${platform}/${version}/${userStatus}/IMG_${imageState.imageIndex}.PNG`;
    img.onload = () => {
      setImageState(prevState => ({
        imageIndex: prevState.imageIndex + 1,
        imageArray: [...prevState.imageArray, img.src],
      }));
    };
    img.onerror = () => {
      setLoading(false);
    };
  }, [imageState, loading, platform, version, userStatus]);

  if (loading) {
    return <CustomSpinner container />;
  }

  if (imageState.imageArray.length === 0) {
    setImageState({
      imageIndex: 2,
      imageArray: ['https://myverifly.com/apptutorial/placeholder.png'],
    });
  }

  return (
    <div className="carousel-component-wrapper">
      <Carousel
        ref={carouselEL}
        activeIndex={index}
        onSelect={handleSelect}
        interval={null}
        indicators={true}
        controls={false}
        wrap={false}
        style={{ height: '85vh', overflow: 'scroll' }}
      >
        {imageState.imageArray.map(slideItem => (
          <Carousel.Item key={slideItem}>
            <img
              className="d-block w-100"
              src={slideItem}
              alt={localize('slide.image')}
            />
          </Carousel.Item>
        ))}
      </Carousel>
      <div
        className={`d-flex pb-2 px-2 mb-3 mx-3 ${
          imageState.imageArray.length !== 1
            ? 'justify-content-between'
            : 'justify-content-end'
        }`}
      >
        {index === 0 && imageState.imageArray.length !== 1 && (
          <div className="p-2" onClick={closeForm}>
            {localize('finish')}
          </div>
        )}
        {index > 0 && (
          <div className="p-2" onClick={handleClick(-1)}>
            {localize('previous')}
          </div>
        )}
        {index < imageState.imageArray.length - 1 && (
          <div className="p-2" onClick={handleClick(1)}>
            {localize('next')}
          </div>
        )}
        {index === imageState.imageArray.length - 1 && (
          <div className="p-2" onClick={closeForm}>
            {localize('finish')}
          </div>
        )}
      </div>
    </div>
  );
};

export default CarouselComp;
